import { createContext } from 'react';

export const FormErrorContext = createContext();

export const FormSectionContext = createContext();
